import styled from "@emotion/styled";

const CustomLabel = styled.div`
  margin-bottom: 13px;
`;

export { CustomLabel };
